import React from 'react'
import { Box } from 'reflexbox'

export default (props) => (
  <Box height="1px" width="auto" bg="dark.1" {...props} />
)
